import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '@mui/material'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

export const UsernameFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  return (
    <TextField
      fullWidth
      name="username"
      margin="dense"
      variant="outlined"
      type="text"
      id="username"
      label={t('labels.username')}
      onChange={(e: React.ChangeEvent<{ value: string }>) => {
        handleChangeSearch('username', e.target.value)
      }}
      InputProps={{
        inputProps: {
          maxLength: 100,
        },
      }}
    />
  )
}
